import React from "react";
import FiatHoldBanner from "../../../customComponents/FiatHoldBanner";
import FiatActivityList from "../FiatActivityPage/FiatActivityList";
import "../DepositFiatPage/depositfiat.css";
import "../FiatActivityPage/fiatActivity.css";
import "./FiatAssetOrder.css";

const FiatAssetOrder = () => {
  return (
    <div className="dashboard_right">
      <div className="dashboard_listing_section2 Overview_mid">
        <div className="listing_left_outer full_width transaction_history_t desktop_view2 so-desktopWrap">
          <main className="so-page" aria-labelledby="so-fiat-activity-title">
            <h1 id="so-fiat-activity-title" className="so-page__title">
              Fiat Activity
            </h1>
            <FiatHoldBanner />
            <FiatActivityList variant="orders" />
          </main>
        </div>
      </div>
    </div>
  );
};

export default FiatAssetOrder;
